import { useState } from 'react';

interface TableSearchProps {
  onSearch: (searchTerm: string) => void;
  containerClasses?: string;
}

const TableSearch: React.FC<TableSearchProps> = ({ onSearch, containerClasses = '' }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value.trim());
  };
  const clearSearch = () => {
    setSearchTerm('');
    onSearch('');
  };
  return (
    <div
      className={`flex items-center self-stretch shrink-0 flex-nowrap relative w-full ${containerClasses}`}
    >
      <div className='flex items-center w-full h-[40px] bg-[#001023] rounded-[8px] border border-solid border-[#4a5463] relative shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] px-[12px]'>
        <span className='ico-search' />
        <input
          type='text'
          placeholder='Search'
          value={searchTerm}
          onChange={handleSearchChange}
          style={{ border: 'none', background: 'transparent', outline: 'none' }}
          className="flex-1 h-[20px] ml-[8px] font-['Mulish'] text-[14px] font-normal leading-[20px] text-[#b8c5cc] bg-transparent border-none"
        />
        {searchTerm && (
          <button
            className='ml-[8px] text-[#b8c5cc] hover:text-white text-[16px] leading-none p-0 m-0 bg-transparent border-none cursor-pointer flex items-center justify-center'
            onClick={clearSearch}
            type='button'
            aria-label='Clear search'
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};
export default TableSearch;
